import React from 'react';
import './TermsConditions.css';

import CtaBanner from '../../components/CtaBanner/CtaBanner';

const TermsConditions = () => {
    return (
        <div className="terms-page">

            {/* HER SECTION */}
            <div className="terms-hero">
                <h1>Terms and Conditions</h1>
            </div>

            <div className="terms-container">
                {/* INTRO */}
                <div className="terms-intro">
                    <h2>Terms and Conditions - Jeevan Realty</h2>
                    <p>
                        Welcome to Jeevan Realty. By accessing and using our website, services, and
                        associated platforms, you agree to comply with and be bound by the following terms
                        and conditions. Please read them carefully before using our services.
                    </p>
                </div>

                {/* POLICY POINTS */}
                <div className="policy-list">

                    {/* 1 */}
                    <div className="policy-card">
                        <div className="policy-number">1</div>
                        <div className="policy-content">
                            <h3>Acceptance of Terms</h3>
                            <p>
                                By accessing our website or using our services, you acknowledge that you have read, understood, and agreed to these terms. If you do not agree with any part of these terms, you must discontinue use immediately.
                            </p>
                        </div>
                    </div>

                    {/* 2 */}
                    <div className="policy-card">
                        <div className="policy-number">2</div>
                        <div className="policy-content">
                            <h3>Use of Services</h3>
                            <p>Our services are intended for individuals looking to buy, sell, or invest in real estate. You agree to:</p>
                            <span className="policy-bullet">Provide accurate and up-to-date information when filling out forms or contacting us.</span>
                            <span className="policy-bullet">Use the website only for lawful purposes and in accordance with these terms.</span>
                            <span className="policy-bullet">Refrain from any activity that disrupts or interferes with our website's functionality.</span>
                        </div>
                    </div>

                    {/* 3 */}
                    <div className="policy-card">
                        <div className="policy-number">3</div>
                        <div className="policy-content">
                            <h3>Property Information</h3>
                            <p>
                                All property details, prices, and availability listed on our website are subject to change without notice. While we strive for accuracy, we do not guarantee the completeness or correctness of the information provided. Users are advised to verify details independently before making any decisions.
                            </p>
                        </div>
                    </div>

                    {/* 4 */}
                    <div className="policy-card">
                        <div className="policy-number">4</div>
                        <div className="policy-content">
                            <h3>Intellectual Property</h3>
                            <p>
                                All content on this website, including text, images, logos, and designs, is the property of Jeevan Realty and is protected by copyright laws. Unauthorized use, reproduction, or distribution of this content is strictly prohibited.
                            </p>
                        </div>
                    </div>

                    {/* 5 */}
                    <div className="policy-card">
                        <div className="policy-number">5</div>
                        <div className="policy-content">
                            <h3>Limitation of Liability</h3>
                            <p>
                                Jeevan Realty shall not be liable for any direct, indirect, incidental, or consequential damages arising from the use or inability to use our services or reliance on any information provided on the website.
                            </p>
                        </div>
                    </div>

                    {/* 6 */}
                    <div className="policy-card">
                        <div className="policy-number">6</div>
                        <div className="policy-content">
                            <h3>Third-Party Links</h3>
                            <p>
                                Our website may contain links to third-party websites for your convenience. We do not endorse or assume responsibility for the content, privacy policies, or practices of these external sites.
                            </p>
                        </div>
                    </div>

                    {/* 7 */}
                    <div className="policy-card">
                        <div className="policy-number">7</div>
                        <div className="policy-content">
                            <h3>Modifications to Terms</h3>
                            <p>
                                We reserve the right to modify these terms and conditions at any time. Changes will be effective immediately upon posting on this page. Your continued use of the website constitutes acceptance of the modified terms.
                            </p>
                        </div>
                    </div>

                    {/* 8 */}
                    <div className="policy-card">
                        <div className="policy-number">8</div>
                        <div className="policy-content">
                            <h3>Governing Law</h3>
                            <p>
                                These terms and conditions are governed by and construed in accordance with the laws of India. Any disputes arising out of these terms shall be subject to the exclusive jurisdiction of the courts in Coimbatore.
                            </p>
                        </div>
                    </div>

                    {/* CONTACT SECTION */}
                    <div className="terms-contact">
                        <h3>Contact Us</h3>
                        <p>If you have any questions regarding these Terms and Conditions, please contact us: Jeevan Realty - Coimbatore</p>
                    </div>

                </div>
            </div>

            {/* CTA SECTION */}
            <CtaBanner />

        </div>
    );
};

export default TermsConditions;
